import { EditOutlined } from "@ant-design/icons";

export const EditablePencilIcon = () => {
  return (
    <EditOutlined
      tabIndex={0}
      onFocus={() => {}}
      className="pencil-edit"
      style={{ color: "grey" }}
    />
  );
};
